import React, { useEffect } from "react";


const QrCodePage = (props) => {

    useEffect(() => {
        window.location = `/`;

    }, []);

    return (

        <div className='transitionPage'>
        </div>
    );
};

export default QrCodePage;